// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"433":"3912f4f9","631":"89dd9aaa","637":"630218cb","737":"9798bf93","768":"c0b0a7de","886":"a923a725"}[chunkId] + ".chunk.js";
};